import { RefreshCw } from 'lucide-react';
import { cn } from 'vendor/shadcn/lib/utils';

const Spinner = ({
  size = 'md',
  animate = true,
}: {
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
  animate?: boolean;
}) => {
  return (
    <div
      className={cn(
        'flex justify-center items-center',
        size === 'xxs' && 'h-4 w-4',
        size === 'xs' && 'h-6 w-6',
        size === 'sm' && 'h-10 w-10',
        size === 'md' && 'h-20 w-20',
        size === 'lg' && 'h-32 w-32'
      )}
    >
      <RefreshCw
        className={cn(
          animate && 'animate-spin',
          'text-primary',
          size === 'xxs' && 'h-4 w-4',
          size === 'xs' && 'h-6 w-6',
          size === 'sm' && 'h-10 w-10',
          size === 'md' && 'h-20 w-20',
          size === 'lg' && 'h-32 w-32'
        )}
      />
    </div>
  );
};

export default Spinner;
